import React from 'react';
import './Arch.css';
import Menu from '../../Menu/Menu';
import b8 from '../../../img/arch2.jpg.crdownload';
import b9 from '../../../img/arch3.jpg';



const Arch = () => {
    return (
        <div className='mb-5'>
            
            <div className='about7'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Architectural Drawing & Structural Design</h1>
                </div>
            </div>

            <div id="gis">
                <h2 className='heading pt-5 px-3'>Architectural Drawing & Structural Design</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3 mb-3'>
                        Our company is a professional engineering company which providing
                        comprehensive architectural and structural engineering services for residential,
                        industrial and commercial projects. Our company believes in providing designs that
                        are functional and economical, working together with our clients to develop
                        complete solutions.<br></br><br></br>
                        Making a construction plan before beginning the construction is imperative. It
                        provides a detailed overview of the building. Keeping that in mind, a different types
                        of drawings is used today for this purpose. Apart from providing the technical details
                        in a readable format, these drawings are also essential to get the project approval.<br></br><br></br>
                        Different types of architectural drawings and structural design which we are
                        done:<br></br>
                        <strong>Site Plan:</strong> A Site Plan is an aerial view of the construction site that includes the
                        primary building and its adjoining constructions.<br></br>
                        <strong>Floor Plan:</strong> This is floor distribution plan. We Prominence for different internal
                        distribution with respect to the client demands and maximum suitable use of
                        floor.<br></br>
                        Cross Section. Elevation ,Landscape, Finishing Drawing, Working Plan,
                        Section Drawings.<br></br>
                        Structurally beam, slab, column, stairs and all type of design & analysis.
                            {/* <img src={b8} alt="" width="100%" className='me-2'/> */}
                        </div>
                        
                        <div className='col-lg-6 col-md-6 col-sm-12 px-lg-5'>
                            <div className='mt-3'>
                                    <img src={b9} alt="" width="100%" className='me-2 mb-3'/>
                                    <img src={b8} alt="" width="100%" className='me-2'/>
                                </div>
                        </div>
                    </div>
                </h5>
            </div>            
        </div>
    );
};

export default Arch;